<template>
  <div class="con-wrap">
    <div class="top">
      <el-button type="primary" @click="goback">返回</el-button>
    </div>
    <div class="alarm-con">
      <div class="query-box">
        <el-form ref="queryForm" :model="queryForm" label-position="left">
          <el-form-item class="query-form alarm-type r-20" label="告警类型:">
            <el-checkbox-group v-model="queryForm.parentType" @change="typeChange">
              <el-checkbox v-for="item in alarmType" :key="item.code" :label="item.code">{{ item.value }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="query-form r-20 warnName" label="告警名称:" label-width="74px">
            <el-select v-model="queryForm.type" placeholder="告警名称" no-data-text="请先选择告警类型" clearable>
              <el-option v-for="item in alarmNameList" :label="item.name" :value="item.type"
                :key="item.type"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="query-form r-20" prop="time" label="告警开始时间:">
            <date-picker :startTime="queryForm.startTime" :endTime="queryForm.endTime" @changeStart="changeStart"
              @changeEnd="changeEnd">
            </date-picker>
          </el-form-item>
          <el-form-item class="query-form r-20" label="所属代维公司:">
            <el-select v-model="queryForm.companyId" placeholder="所属代维公司" clearable>
              <el-option v-for="item in devopsList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="query-form r-20 plateNum" label="车牌号:" label-width="60px">
            <el-input v-model="queryForm.plate" placeholder="车牌号"></el-input>
          </el-form-item>
          <el-form-item class="query-form r-20" prop="time1" label="告警解除时间:">
            <date-picker :startTime="queryForm.rStartTime" :endTime="queryForm.rEndTime" @changeStart="changeStart1"
              @changeEnd="changeEnd1">
            </date-picker>
          </el-form-item>
          <el-form-item class="query-form r-20 deptId" label-width="74px" label="所属部门:">
            <el-cascader ref="cascader_ref" v-model="queryForm.deptIds" :options="deptList" :props="optionProps"
              clearable collapse-tags placeholder="所属部门"></el-cascader>
            <!-- <el-select
              v-model="queryForm.deptIds"
              clearable
              placeholder="所属部门"
            >
              <el-option
                v-for="item in deptList"
                :key="item.id"
                :label="item.label"
                :value="item.id"
              ></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item class="query-form r-20">
            <el-button v-if="hasPerm('warn:remind:list')" type="primary" @click="query">查询</el-button>
            <el-button v-if="hasPerm('warn:remind:list')" @click="reset">取消</el-button>
          </el-form-item>
          <div style="margin-bottom: 20px">
            <el-button v-if="hasPerm('warn:remind:list')" type="primary" class="btn-width"
              @click="dayHistoryAlarm">今日历史告警</el-button>
            <el-button v-if="hasPerm('warn:remind:list')" type="primary" class="btn-width"
              @click="monthHistoryAlarm">本月历史告警</el-button>
            <el-button v-if="hasPerm('warn:remind:export')" type="primary" @click="alarmRelieve">导出Excel</el-button>
            <el-button v-if="
              hasPerm(
                'warn:remind:history:stat,warn:remind:maintenance:personnel'
              )
            " type="primary" class="btn-width" @click="historyAlarm">历史告警统计</el-button>
          </div>
        </el-form>
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" size="mini" stripe
          height="560px" highlight-current-row @row-click="packageClickTableRow">
          <el-table-column type="index" align="center" label="序号" width="55"></el-table-column>
          <el-table-column prop="warnType" label="告警类型" width="96" show-overflow-tooltip></el-table-column>

          <el-table-column prop="warnName" label="告警名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="startTime" label="告警开始时间" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="takeTime" label="告警历时(分钟)" min-width="110" show-overflow-tooltip></el-table-column>
          <el-table-column prop="relieveSubject" label="解除人" width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="relieveTime" label="解除时间" show-overflow-tooltip></el-table-column>
          <el-table-column prop="relieveMsg" label="解除说明" show-overflow-tooltip></el-table-column>
          <el-table-column prop="vin" label="车架号" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="plate" label="车牌号" width="90" show-overflow-tooltip>
            <template slot-scope="scope">
              <span @click.stop="gotoMonitor(scope.row.lnglat)" class="plate">{{
                scope.row.plate
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ownerName" label="车辆绑定人" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="companyName" label="所属代维公司" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="deptName" label="所属部门" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="groupName" label="所属运维小组" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="160" prop="warnName">
            <template slot-scope="scope">
              <el-button size="mini" type="text" v-if="
                hasPerm('vehicle:details:status,vehicle:details:basic:info')
              " @click.stop="vehicleDetail(scope.row)">车辆详情</el-button>
              <el-button type="text" @click="toAlarmDetails(scope.row)">告警详情</el-button>
              <!-- <el-button
                size="mini"
                type="text"
                @click.stop="alarmDetail(scope.row)"
                v-if="
                  scope.row.warnName == '违规加油' &&
                    hasPerm('warn:remind:details:info')
                "
                >告警详情</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="currentPage" :page-size="limit" layout="total, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>
    </div>
    <el-dialog title="历史告警统计" :visible.sync="AlarmVisible" class="alarmDialog">
      <div class="selectBox">
        <el-form ref="dQueryForm" :model="dQueryForm">
          <el-form-item class="query-form r-20" label="部门:">
            <el-input class="selectInput" v-model="udeptName" @click.native="clickInput" readonly></el-input>
          </el-form-item>
          <el-form-item class="query-form r-20" label="运维人员:">
            <el-select v-model="dQueryForm.personalId" placeholder="请选择运维人员" no-data-text="该部门下暂无运维人员" clearable>
              <el-option v-for="item in staffNameList" :label="item.name" :value="item.personnelId"
                :key="item.personnelId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="query-form r-20">
            <el-button type="primary" @click="queryCount">查询</el-button>
          </el-form-item>
          <el-form-item class="time-con">
            <el-radio-group v-model="dQueryForm.timeType" @change="timeChange">
              <el-radio-button label="1"> 本周 </el-radio-button>
              <el-radio-button label="2">本月 </el-radio-button>
              <el-radio-button label="3">本季度 </el-radio-button>
              <el-radio-button label="4"> 本年度 </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="deptTree" :class="{ active: show == true }">
          <div class="custom-tree-container">
            <div class="block">
              <el-tree :data="udeptTreeData" node-key="id" @node-click="getUserList" default-expand-all
                highlight-current :expand-on-click-node="false">
                <span class="custom-tree-node is-show" slot-scope="{ node }">
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
      </div>
      <div class="countBox">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-popover placement="right" width="188" trigger="hover">
              <div style="padding:0 6px">
                <div v-if="vehicleList.length != 0">
                  <p class="child-p" v-for="item in vehicleList" :key="item.type">
                    <span>{{ item.name }}：</span>
                    <span style="color:#F6392A">{{ item.count }}</span>
                  </p>
                </div>
                <div v-else>暂无告警</div>
              </div>
              <div class="count-con" slot="reference">
                <p class="count-num vehicle">{{ warnCount.vehicleCount }}</p>
                <p class="alarmName">车辆告警（条）</p>
              </div>
            </el-popover>
          </el-col>
          <el-col :span="6">
            <el-popover placement="right" width="188" trigger="hover">
              <div style="padding:0 6px">
                <div v-if="dynamoList.length != 0">
                  <p class="child-p" v-for="item in dynamoList" :key="item.type">
                    <span>{{ item.name }}：</span>
                    <span style="color:#F6392A">{{ item.count }}</span>
                  </p>
                </div>
                <div v-else>暂无告警</div>
              </div>
              <div class="count-con" slot="reference">
                <p class="count-num dynamo">{{ warnCount.dynamoCount }}</p>
                <p class="alarmName">发电告警（条）</p>
              </div>
            </el-popover>
          </el-col>
          <el-col :span="6">
            <el-popover placement="right" width="188" trigger="hover">
              <div style="padding:0 6px">
                <div v-if="violationList.length != 0">
                  <p class="child-p" v-for="item in violationList" :key="item.type">
                    <span>{{ item.name }}：</span>
                    <span style="color:#F6392A">{{ item.count }}</span>
                  </p>
                </div>
                <div v-else>暂无告警</div>
              </div>

              <div class="count-con" slot="reference">
                <p class="count-num violation">
                  {{ warnCount.violationCount }}
                </p>
                <p class="alarmName">违规操作告警（条）</p>
              </div>
            </el-popover>
          </el-col>
          <el-col :span="6">
            <el-popover placement="left" width="188" trigger="hover">
              <div style="padding:0 6px">
                <div v-if="maintenanceList.length != 0">
                  <p class="child-p" v-for="item in maintenanceList" :key="item.type">
                    <span>{{ item.name }}：</span>
                    <span style="color:#F6392A">{{ item.count }}</span>
                  </p>
                </div>
                <div v-else>暂无告警</div>
              </div>
              <div class="count-con" slot="reference">
                <p class="count-num maintenance">
                  {{ warnCount.maintenanceCount }}
                </p>
                <p class="alarmName">维保告警（条）</p>
              </div>
            </el-popover>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="padding-top:40px">
          <el-col :span="6">
            <el-popover placement="right" width="188" trigger="hover">
              <div style="padding:0 6px">
                <div v-if="orderList.length != 0">
                  <p class="child-p" v-for="item in orderList" :key="item.type">
                    <span>{{ item.name }}：</span>
                    <span style="color:#F6392A">{{ item.count }}</span>
                  </p>
                </div>
                <div v-else>暂无告警</div>
              </div>
              <div class="count-con" slot="reference">
                <p class="count-num order">
                  {{ warnCount.orderCount }}
                </p>
                <p class="alarmName">工单告警（条）</p>
              </div>
            </el-popover>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- 违规加油告警详情 -->
    <el-dialog title="违规加油告警详情" :visible.sync="visible">
      <div id="open-map"></div>
      <div class="box">
        <p class="box-row">
          <span class="labels">起始点时间：</span>
          <span>{{ detailsCon.startTime }}</span>
        </p>
        <p class="box-row">
          <span class="labels">结束点时间：</span>
          <span>{{ detailsCon.endTime }}</span>
        </p>
        <p class="box-row">
          <span class="labels">起始点油量(升)：</span>
          <span>{{ detailsCon.startOil }}</span>
        </p>
        <p class="box-row">
          <span class="labels">结束点油量(升)：</span>
          <span class="vals">{{ detailsCon.endOil }}</span>
        </p>
        <p class="box-row">
          <span class="labels">本次加油量(升)：</span>
          <span>{{ detailsCon.endOil - detailsCon.startOil }}</span>
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import AMap from "AMap";
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      queryForm: {
        parentType: [],
        type: "",
        startTime: "",
        endTime: "",
        plate: "",
        rStartTime: "",
        rEndTime: "",
        companyId: "",
        deptIds: [],
      },
      optionProps: {
        value: "id",
        multiple: true,
        emitPath: true,
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      tableData: [],
      alarmType: [],
      devopsList: [],
      deptList: [],
      alarmNameList: [],
      AlarmVisible: false,
      udeptTreeData: [],
      show: false,
      udeptName: "",
      staffNameList: [],
      dQueryForm: {
        deptId: "",
        personalId: "",
        timeType: 2,
      },
      dynamoList: [],
      maintenanceList: [],
      violationList: [],
      vehicleList: [],
      orderList: [],
      warnCount: {},
      // 告警详情
      visible: false,
      startMarker: "",
      endMarker: "",
      markers: [],
      content: [],
      startPosition: [],
      endPosition: [],
      geocoder: {},
      startInfoWindow: "",
      endInfoWindow: "",
      detailsCon: "",
      //防止每次数据改变重置定位地图
      opnMap: null,
    };
  },
  updated() {
    this.opnMap = new AMap.Map("open-map", {
      // center: [116.397428, 39.90923],
      resizeEnable: true,
      zoom: 20,
    });
    AMap.plugin("AMap.Geocoder", () => {
      this.geocoder = new AMap.Geocoder({
        city: "全国", //城市设为北京，默认：“全国”
        radius: 1000, //范围，默认：500
      });
    });
  },
  created() {
    if (this.$route.params.historyAlarmCurPage) {
      this.queryForm = JSON.parse(sessionStorage.getItem("historyAlarmQuery"));
      this.currentPage = parseInt(
        sessionStorage.getItem("historyAlarmCurPage")
      );
    }
    if (this.$route.params.currentPage) {
      this.currentPage = parseInt(
        sessionStorage.getItem("historyAlarmCurrentPage")
      );
    }
    this.getAlarmList();
    this.getAlarmType();
    this.getDevCompany();
    this.getDeptList();
  },
  watch: {
    "queryForm.parentType"(val) {
      let _this = this;
      if (val) {
        this.$nextTick(() => {
          _this.getAlarmNameList();
        });
      }
    },
    udeptTreeData(val) {
      if (val) {
        this.show = true;
        this.$nextTick(() => {
          document.querySelector(".block .el-tree-node__content").click();
        });
      }
    },
  },
  methods: {
    async getDeptList() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/dept/listDept");
      if (res.code == 1) {
        let data = _this.handleTreeData(res.data);
        _this.deptList = data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // el-cascader 控件 最后一级出现空白 暂无数据 页面
    handleTreeData(data) {
      data.forEach((item) => {
        if (item.children.length == 0) {
          item.children = undefined;
        } else {
          this.handleTreeData(item.children);
        }
      });
      return data;
    },
    goback() {
      this.$router.push({
        name: "AlarmMonitor",
      });
    },
    // ？？？ 新增跳转详情
    toAlarmDetails(row) {
      // 跳转至告警详情页面
      this.$router.push({
        name: "AlarmDetails",
        params: {
          historyId: row.id,
          historyVin: row.vin,
        },
      });
      console.log(row);
      // 返回进来时的页面
      sessionStorage.setItem("historyAlarmCurrentPage", this.currentPage);
    },
    // 跳转至运行监控
    gotoMonitor(lnglat) {
      sessionStorage.setItem("monitorLnglat", lnglat);
      sessionStorage.setItem("isSearch", false);
      const { href } = this.$router.resolve({
        path: "/fullScreenMonitor",
      });
      window.open(href, "_blank");
    },
    // 告警类型切换
    typeChange(val) {
      this.queryForm.parentType = val;
      this.queryForm.type = "";
    },
    // 告警类型
    async getAlarmType() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/sys/dict/" + "warnRemind"
      );
      if (res.code == 1) {
        _this.alarmType = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //所属代维公司
    async getDevCompany() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/warn/remind/company");
      if (res.code == 1) {
        _this.devopsList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //获取告警名称列表
    async getAlarmNameList() {
      let _this = this;
      let obj = {
        parentType: _this.queryForm.parentType.toString(),
      };
      let { data: res } = await _this.$axios.get("/api/warn/remind/type", {
        params: obj,
      });
      if (res.code == 1) {
        _this.alarmNameList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //获取告警列表数据
    async getAlarmList() {
      let _this = this;
      let obj = {};
      obj.parentType = _this.queryForm.parentType.toString();
      obj.type = _this.queryForm.type;
      obj.warnStartTime = _this.queryForm.startTime;
      obj.warnEndTime = _this.queryForm.endTime;
      obj.plate = _this.queryForm.plate;
      obj.relieveStartTime = _this.queryForm.rStartTime;
      obj.relieveEndTime = _this.queryForm.rEndTime;
      obj.companyId = _this.queryForm.companyId;
      obj.deptIds = _this.queryForm.deptIds.join(",");
      obj.warnStatus = 2;
      obj.limit = _this.limit;
      obj.page = _this.currentPage;
      let { data: res } = await _this.$axios.get("/api/warn/remind/list", {
        params: obj,
      });
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    query() {
      this.getAlarmList();
    },
    reset() {
      this.queryForm.parentType = [];
      this.queryForm.type = "";
      this.queryForm.startTime = "";
      this.queryForm.endTime = "";
      this.queryForm.plate = "";
      this.queryForm.rStartTime = "";
      this.queryForm.rEndTime = "";
      this.queryForm.companyId = "";
      this.queryForm.deptIds = [];
      this.getAlarmList();
    },
    packageClickTableRow(row, event, column) {
      console.log(row);
      console.log(column);
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getAlarmList();
    },
    changeStart(val) {
      this.queryForm.startTime = val;
    },
    changeEnd(val) {
      this.queryForm.endTime = val;
    },
    changeStart1(val) {
      this.queryForm.rStartTime = val;
    },
    changeEnd1(val) {
      this.queryForm.rEndTime = val;
    },
    // 获取今日告警历史
    dayHistoryAlarm() {
      const yy = new Date().getFullYear();
      const mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      const dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      this.queryForm.startTime = yy + "-" + mm + "-" + dd + " " + "00:00:00";
      this.queryForm.endTime = this.$nowDate();
      this.getAlarmList();
    },
    // 获取本月告警历史
    monthHistoryAlarm() {
      const yy = new Date().getFullYear();
      const mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      this.queryForm.startTime = yy + "-" + mm + "-" + "01" + " " + "00:00:00";
      this.queryForm.endTime = this.$nowDate();
      this.getAlarmList();
    },
    //数据导出
    alarmRelieve() {
      let _this = this;
      _this
        .$confirm("确定导出当前查询数据吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "success",
        })
        .then(async () => {
          let obj = {};
          let url = "";
          obj.parentType = _this.queryForm.parentType.toString();
          obj.type = _this.queryForm.type;
          obj.warnStartTime = _this.queryForm.startTime;
          obj.warnEndTime = _this.queryForm.endTime;
          obj.plate = _this.queryForm.plate;
          obj.relieveStartTime = _this.queryForm.rStartTime;
          obj.relieveEndTime = _this.queryForm.rEndTime;
          obj.companyId = _this.queryForm.companyId;
          url =
            "/api/warn/remind/export?parentType=" +
            obj.parentType +
            "&type=" +
            obj.type +
            "&warnStartTime=" +
            obj.warnStartTime +
            "&warnEndTime=" +
            obj.warnEndTime +
            "&companyId=" +
            obj.companyId +
            "&plate=" +
            obj.plate +
            "&relieveStartTime=" +
            obj.relieveStartTime +
            "&relieveEndTime=" +
            obj.relieveEndTime +
            "&warnStatus=2";
          window.location.href = url;
        });
    },
    historyAlarm() {
      this.getDeptTree();
      this.dQueryForm.personalId = "";
      this.AlarmVisible = true;
    },
    clickInput() {
      this.show = !this.show;
    },
    // 获取部门树
    async getDeptTree() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/dept/list");
      if (res.code == 1) {
        _this.udeptTreeData = res.data;
        _this.dQueryForm.deptId = _this.udeptTreeData[0].id;
        _this.udeptName = _this.udeptTreeData[0].label;
        _this.getaAlarmCount();
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getUserList(data) {
      let _this = this;
      _this.udeptName = data.label;
      _this.dQueryForm.deptId = data.id;
      _this.show = !_this.show;
      let parm = {
        deptId: data.id,
      };
      let { data: res } = await _this.$axios.get(
        "/api/warn/remind/maintenance/personnel",
        {
          params: parm,
        }
      );
      if (res.code == 1) {
        // if (res.data.length == 0) {
        //   _this.staffNameList = []
        // }
        _this.dQueryForm.personalId = "";
        _this.staffNameList = res.data;
      } else {
        _this.staffNameList = [];
        _this.$message.warning(res.msg);
      }
    },
    //时间修改，默认查询告警统计
    timeChange() {
      this.getaAlarmCount();
      console.log(this.dQueryForm.timeType + "1111111");
    },
    queryCount() {
      this.getaAlarmCount();
    },
    async getaAlarmCount() {
      let _this = this;
      let parm = {
        deptId: _this.dQueryForm.deptId,
        personalId: _this.dQueryForm.personalId,
        timeType: _this.dQueryForm.timeType,
      };
      let { data: res } = await _this.$axios.get(
        "/api/warn/remind/history/stat",
        {
          params: parm,
        }
      );
      if (res.code == 1) {
        _this.dynamoList = res.data.dynamoList;
        _this.maintenanceList = res.data.maintenanceList;
        _this.orderList = res.data.orderList;
        _this.violationList = res.data.violationList;
        _this.vehicleList = res.data.vehicleList;
        _this.warnCount = res.data.warnCount;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    vehicleDetail(rowData) {
      sessionStorage.setItem("pathUrl", "/HistoryAlarm");
      sessionStorage.setItem(
        "historyAlarmQuery",
        JSON.stringify(this.queryForm)
      );
      sessionStorage.setItem("historyAlarmCurPage", this.currentPage);
      this.$router.push({
        name: "VehicleInfo",
        params: {
          vin: rowData.vin,
          active: "real",
        },
      });
    },
    //告警详情
    alarmDetail(rowData) {
      //设置弹框标题
      this.warnBusId = rowData.warnBusId;
      this.getAlarmData();
    },
    //违规加油告警详情--start
    async getAlarmData() {
      let _this = this;
      let obj = {
        warnBusId: _this.warnBusId,
      };
      let { data: res } = await _this.$axios.get(
        "/api/warn/remind/details/info",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        if (res.data) {
          _this.detailsCon = res.data.data;
          _this.location(res.data.data);
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 查询加油前后定位
    location(data) {
      let _this = this;
      this.visible = true;
      this.clickFlag = true;
      console.log(data.startLongitude);
      _this.startPosition = [data.startLongitude, data.startLatitude];
      _this.endPosition = [data.endLongitude, data.endLatitude];
      //清理覆盖物
      if (_this.startMarker || _this.endMarker) {
        _this.opnMap.remove(_this.startMarker);
        _this.opnMap.remove(_this.endMarker);
      }
      _this.startMarker = new AMap.Marker({
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: _this.startPosition,
      });
      _this.endMarker = new AMap.Marker({
        icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png",
        position: _this.endPosition,
      });
      _this.getAddr(_this.startPosition, "1");
      _this.getAddr(_this.endPosition, "2");
      _this.$nextTick(() => {
        // 更改地图中心点
        _this.opnMap.setCenter(_this.startPosition);
        _this.opnMap.add([_this.startMarker, _this.endMarker]);

        AMap.event.addListener(_this.startMarker, "click", function () {
          _this.opnMap.clearInfoWindow();
          _this.startInfoWindow.open(
            _this.opnMap,
            _this.startMarker.getPosition()
          );
        });
        AMap.event.addListener(_this.endMarker, "click", function () {
          _this.opnMap.clearInfoWindow();
          _this.endInfoWindow.open(_this.opnMap, _this.endMarker.getPosition());
        });
      });
    },
    getAddr(position, flag) {
      // 确保 geocoder 已初始化
      if (!this.geocoder) {
        console.error("Geocoder 未初始化，请检查插件加载");
        return;
      }
      let _this = this;
      _this.geocoder.getAddress(position, function (status, result) {
        if (status === "complete" && result.regeocode) {
          _this.content = [];
          if (flag === "2") {
            _this.content.push(
              "<p><span style='margin-right:6px'>结束点位置: </span>" +
              result.regeocode.formattedAddress +
              "</p>"
            );
            _this.endInfoWindow = new AMap.InfoWindow({
              isCustom: true,
              content: _this.createInfoWindow(_this.content),
              offset: new AMap.Pixel(16, -45),
            });
          } else {
            _this.content.push(
              "<p><span style='margin-right:6px'>起始点位置: </span>" +
              result.regeocode.formattedAddress +
              "</p>"
            );
            _this.startInfoWindow = new AMap.InfoWindow({
              isCustom: true,
              content: _this.createInfoWindow(_this.content),
              offset: new AMap.Pixel(16, -45),
            });
          }
          //   _this.information.address = result.regeocode.formattedAddress
        } else {
          _this.$message.warning("根据经纬度查询地址失败");
        }
      });
    },
    createInfoWindow() {
      let _this = this;
      var info = document.createElement("div");
      info.style.background = "#fff";
      info.style.height = "80px";
      info.style.border = "1px solid #ccc";
      info.style.borderRadius = "4px";
      //顶部内容
      var top = document.createElement("div");
      top.style.height = "26px";
      top.style.position = "relative";
      info.className = "realtimeLocation";
      var closeX = document.createElement("img");
      closeX.style.position = "absolute";
      closeX.style.top = "10px";
      closeX.style.right = "10px";
      closeX.style.cursor = "pointer";
      closeX.src = "https://webapi.amap.com/images/close2.gif";
      closeX.addEventListener("click", () => {
        _this.opnMap.clearInfoWindow();
      });
      top.appendChild(closeX);
      info.appendChild(top);
      // 定义中部内容
      var middle = document.createElement("div");
      middle.style.backgroundColor = "white";
      middle.style.padding = "0 20px";
      middle.style.color = "#333";
      middle.innerHTML = this.content;
      info.appendChild(middle);
      //底部内容
      var bottom = document.createElement("div");
      bottom.style.position = "relative";
      bottom.style.width = "30px";
      bottom.style.top = "16px";
      bottom.style.left = "146px";
      var sharp = document.createElement("img");
      sharp.src = "https://webapi.amap.com/images/sharp.png";
      bottom.appendChild(sharp);
      info.appendChild(bottom);
      return info;
    },
    //违规加油告警详情--end
  },
};
</script>

<style lang="scss" scoped>
.top {
  margin-bottom: 10px;
}

.con-wrap {
  height: calc(100% - 40px);
  overflow: hidden;
  font-size: 14px;
  color: #333;

  // 隐藏全选框
  /deep/ .el-table__header-wrapper .el-table-column--selection .cell {
    display: none;
  }

  /deep/ .el-form-item {
    margin-bottom: 14px !important;
  }
}

//内容
.alarm-con /deep/ {
  width: 100%;
  height: calc(100% - 38px);
  margin-top: 10px;
  padding: 20px;
  background-color: #fff;
  box-sizing: border-box;
  overflow: auto;

  .query-form {
    display: inline-block;

    .el-select {
      width: 260px;
    }

    .el-input {
      width: 260px;
    }

    .el-form-item__label,
    .el-form-item__content {
      float: left;
    }
  }

  .alarm-type {
    display: block !important;

    .el-checkbox-group {
      height: 22px;
    }

    .el-form-item__label,
    .el-form-item__content {
      line-height: 22px !important;
      float: left;
    }
  }

  .el-table {
    height: 530px !important;
  }
}

.btn-width {
  width: 108px;
}

.plate {
  color: #0094ff;
  cursor: pointer;
}

.r-20 /deep/ {
  .el-form-item__label {
    width: 106px;
  }

  .el-col-1 {
    margin-left: 30px !important;
    text-align: center;
  }
}

// 告警统计
.alarmDialog /deep/ {
  .el-dialog {
    width: 1200px;
    box-sizing: border-box;
  }

  .el-form-item__content {
    float: left;
    width: 260px;
  }

  .r-20 .el-form-item__label {
    width: 72px;
  }

  .query-form {
    display: inline-block;
  }
}

.warnName,
.plateNum,
.deptId {
  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
}

.selectBox {
  width: 100%;
  position: relative;
}

.selectBox .selectInput /deep/ .el-input__inner {
  cursor: pointer !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.deptTree {
  width: 260px;
  height: 400px;
  overflow: auto;
  margin-left: 18px;
  position: absolute;
  top: 36px;
  left: 54px;
  font-size: 14px;
  display: none;
  z-index: 2;
}

.deptTree.active {
  display: block;
}

.time-con /deep/ {
  .el-radio-group {
    width: 420px;
    height: 100%;
    margin: 0 auto;
  }

  .el-radio-button__inner {
    width: 100%;
    height: 100%;
    float: left;
    line-height: 32px;
    padding: 0;
    box-sizing: initial;
    border: 0;
  }

  .el-radio-button.is-actived .el-radio-button__inner {
    background: #0094ff;
    color: #fff;
    border-color: #0094ff;
  }

  .el-radio-button__orig-radio {
    left: 0;
  }

  .el-radio-button:first-child .el-radio-button__inner {
    border: 0;
  }

  .el-radio-button {
    width: 80px;
    height: 32px;
    overflow: hidden;
    line-height: 32px;
    margin: 10px;
    text-align: center;
    font-size: 14px;
    color: #333;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
}

.countBox /deep/ {
  width: 100%;
  height: 390px;
  padding: 40px 46px 0;
  box-sizing: border-box;

  .count-con {
    width: 160px;
    height: 100px;
    margin: 0 auto;
    background-color: #f2f6f9;
    border-radius: 12px;
    cursor: pointer;
    font-size: 14px;
    text-align: center;

    .count-num {
      height: 68px;
      line-height: 68px;
      font-size: 26px;
      font-family: Microsoft YaHei;
      font-weight: 400;
    }

    .vehicle {
      color: #a380dd;
    }

    .dynamo {
      color: #03c1d6;
    }

    .violation {
      color: #e59d4a;
    }

    .maintenance {
      color: #04d568;
    }

    .order {
      color: #1074f6;
    }
  }

  .count-con:hover {
    background-color: #e2e6ea;
  }
}

/deep/ .child-p {
  height: 28px;
  line-height: 28px !important;
}

#open-map {
  width: 100%;
  height: 580px;
}

.box {
  height: 160px;
  line-height: 28px;
  border-radius: 6px;
  padding: 10px 20px;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
  box-sizing: border-box;
  position: absolute;
  top: 60px;
  left: 20px;

  .box-row {
    .labels {
      display: inline-block;
      text-align: right;
      width: 110px;
    }
  }
}

::v-deep .el-cascader {
  input {
    height: 32px !important;
  }

  .el-cascader__tags {
    width: 64%;
    flex-wrap: nowrap;
  }
}
</style>
